import { IComponent }                     from '@/Interface/IComponent';
import { Component, h, JSX, Prop, State } from '@stencil/core';

@Component({
    tag:      'nes-debugger-frame',
    styleUrl: './nes-debugger-frame.scss',
    shadow:   true,
})
export class NesDebuggerFrame implements IComponent
{
    @Prop() public label: string = 'Untitled Frame';

    @State() private collapsed: boolean = false;

    public componentWillLoad(): void
    {
        this.collapsed = !! localStorage.getItem(`_FC[${this.label}]`);
    }

    public render(): JSX.Element
    {
        return (
            <main class={{collapsed: this.collapsed}}>
                <header onClick={() => this.toggle()}>
                    <span>{this.label}</span>
                    <span>{this.collapsed ? '+' : '-'}</span>
                </header>
                <section>
                    <slot/>
                </section>
            </main>
        );
    }

    private toggle(): void
    {
        this.collapsed = !this.collapsed;
        localStorage.setItem(`_FC[${this.label}]`, this.collapsed ? '1' : '');
    }
}
